export const deClientPortalApprovalModal = {
    actions: {},
    items: {
        requestFinalisationAfterComments: 'Finalisierung des Gutachtens nach Einarbeitung der Anmerkungen anfordern',
        requestFinalisation: 'Finalisierung des Gutachtens anfordern',
    },
    warningText: 'Sie können nach der Freigabe Anmerkungen nicht mehr zu diesem Entwurf hinzufügen, bearbeiten oder löschen.',
    confirmationLabel: 'Ich bestätige, dass ich den Entwurf zur Finalisierung freigebe.',
}
